import styled from 'styled-components';
import { ChevronDownIcon } from '@root/styles/icons';

export const OpenIndicator = styled(ChevronDownIcon)<{ $isOpen: boolean }>`
  transition: 0.5s;
  margin-right: -12px;

  ${({ $isOpen }) =>
    $isOpen &&
    `
    transform: rotate(180deg);
  `}
`;
